/************************************************************************************
* [COMPONENT]: PRODUCT PAGE - GENERAL JS
*************************************************************************************/

if (!customElements.get('l-product-variants-reset-info')) {
  class LTAProductVariantsResetInfo extends HTMLElement {
    constructor() { super() }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;

      document.addEventListener('l:variant:changed', () => {
        this.productSelectIdEl = this.productSelectIdEl || document.getElementById(`ProductSelect-${this.sectionId}`);
        this.variantContentEls = this.variantContentEls || this.querySelectorAll('[data-variant]');
        if (!this.productSelectIdEl) return;

        const selectedVariantId = this.productSelectIdEl.value;
        this.variantContentEls.forEach((el) => {
          el.classList.toggle('hidden', el.dataset.variant != selectedVariantId);
        });
      });
    }
  }

  customElements.define('l-product-variants-reset-info', LTAProductVariantsResetInfo);
}

document.addEventListener('DOMContentLoaded', function () {

  // Close menu on scroll
  window.addEventListener("scroll", function() {
    document.querySelectorAll(".mega-menu--dropdown-wrapper.open").forEach(menu => menu.classList.remove("open"));
  });

  // Close menu on overlay click
  document.addEventListener("click", function(e) {
    if (e.target.closest(".mega-menu--dropdown-wrapper .fixed-overlay")) {
      document.querySelectorAll(".mega-menu--dropdown-wrapper.open").forEach(menu => menu.classList.remove("open"));
    }
  });

  // Clear purchase text
  const purchaseTextEl = document.querySelector('.purchase-text');
  if (purchaseTextEl) purchaseTextEl.textContent = '';

  // Slide menu carts
  document.querySelectorAll('.slide-menu-cart').forEach(slideMenuCart => {
    slideMenuCart.addEventListener('click', function (e) {
      e.preventDefault();
      Rebuy.SmartCart.show();
      setTimeout(custom_closecartdrawer, 500);
    });
  });

  // Sticky Add to Cart scroll and footer handling
  const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
  const submitAction = document.querySelector('.product-page--submit-action') || document.querySelector('.gf_add-to-cart.product-form-product-template');

  if (stickyAddToCart && submitAction) {
    const btnLinkJsEl = stickyAddToCart.querySelector('.btn.secondary-button');
    if (btnLinkJsEl) {
      btnLinkJsEl.addEventListener('click', e => {
        e.preventDefault();
        submitAction.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    function updateStickyAddToCartPosition() {
      const footerGroup = document.querySelector('.shopify-section-group-footer-group');
      const bottomFooter = document.querySelector('.bottom-footer');
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      if (stickyAddToCart.dataset.moved !== 'true' && footerGroup) {
        footerGroup.parentNode.insertBefore(stickyAddToCart, footerGroup.nextSibling);
        stickyAddToCart.dataset.moved = 'true';
      }

      const submitActionTop = submitAction.getBoundingClientRect().top + window.scrollY;
      const isActive = window.scrollY > submitActionTop;

      stickyAddToCart.classList.toggle('active', isActive);
      document.body.classList.toggle('satc-active', isActive);

      if (isMobile) {
        stickyAddToCart.style.top = '';
        stickyAddToCart.style.bottom = '0';

        const barHeight = stickyAddToCart.offsetHeight;
        document.documentElement.style.setProperty('--satc-height', barHeight + 'px');

        if (bottomFooter) {
          bottomFooter.style.marginBottom = isActive ? barHeight + 'px' : '';
        }
      } else {
        stickyAddToCart.style.bottom = '';
        const stickyHeader = document.querySelector('.sticky-header-wrapper.sticky');
        const headerHeight = stickyHeader?.offsetHeight || 0;
        stickyAddToCart.style.top = headerHeight - 1 + 'px';

        document.documentElement.style.removeProperty('--satc-height');
        if (bottomFooter) bottomFooter.style.marginBottom = '';
      }
    }

    updateStickyAddToCartPosition();
    window.addEventListener('scroll', updateStickyAddToCartPosition, { passive: true });
    window.addEventListener('resize', updateStickyAddToCartPosition);
  }

  // Rebuy cart count updates
  function updateHeaderCartCount(count) {
    document.querySelectorAll('.cart-item-count-header').forEach(el => {
      el.textContent = count.toString();
      el.classList.toggle('hidden', count === 0);
    });
  }

  document.addEventListener('rebuy:cart.change', e => updateHeaderCartCount(e?.detail?.cart?.cart.item_count ?? 0));
  document.addEventListener('rebuy:cart.updated', e => updateHeaderCartCount(e?.detail?.cart?.item_count ?? 0));

  if (window.Rebuy) {
    window.Rebuy.on('cart.change', cart => updateHeaderCartCount(cart?.item_count ?? 0));
    window.Rebuy.on('cart.updated', cart => updateHeaderCartCount(cart?.item_count ?? 0));
  }

  // Variant reload
  jQuery(function () {
    $('.single-option-selector').on('change', function () {
      setTimeout(function () {
        if ($('[name="id"]').val() != '{{ product.selected_or_first_available_variant.id }}') {
          location.reload();
        }
      }, 1);
    });
  });

});

function custom_closecartdrawer() {
  jQuery('#slideout-overlay').hide();
  jQuery('.slideout-menu').addClass('slideout-panel-hidden');
  jQuery('.slideout-panel-right').attr('style', '');
}



document.addEventListener('DOMContentLoaded', function () {

  // Function to extract only price
  function extractPrice(text) {
    // Match last $ followed by numbers (with optional commas/decimals)
    const match = text.match(/\$\d+(?:[\d,]*)(?:\.\d{2})?/);
    return match ? match[0] : text.trim(); // fallback to original text if no match
  }

  // Function to update sticky price
  function updateStickyPrice(priceText) {
    const stickyPriceEl = document.querySelector('#sticky-variant-price');
    const buttonPricingEl = document.querySelector('.button-pricing span');
    const priceInput = document.getElementById('price-input');

    if (!stickyPriceEl) return;

    stickyPriceEl.innerHTML = `<span class="price">${priceText}</span>`;
    if (buttonPricingEl) buttonPricingEl.textContent = priceText;
    if (priceInput) priceInput.value = priceText;

    console.log('✅ Sticky price updated:', priceText);
  }

  // Observe the price field for changes
  const priceFieldEl = document.querySelector('#price-field');
  if (priceFieldEl) {
    const observer = new MutationObserver(() => {
      const fullText = priceFieldEl.querySelector('.money')?.textContent.trim();
      if (fullText) {
        const priceOnly = extractPrice(fullText);
        updateStickyPrice(priceOnly);
      }
    });

    observer.observe(priceFieldEl, { childList: true, subtree: true, characterData: true });
  }

  // Also trigger on page load
  const initialFullText = priceFieldEl?.querySelector('.money')?.textContent.trim();
  if (initialFullText) {
    const initialPrice = extractPrice(initialFullText);
    updateStickyPrice(initialPrice);
  }

});
